import React, { Fragment } from 'react'
import { Users, Volume2, Calendar, LocationEdit, LocateOffIcon, Locate, LocateFixed, Clapperboard, Info } from 'lucide-react'

const CinemaInfo = () => {
  const infoItems = [
    {
      icon: <Clapperboard size={24} className='text-[#AC5E2A]' />,
      label: 'Film',
      value: 'Bi Umut',
    },
    {
      icon: <LocateFixed size={24} className='text-[#AC5E2A]' />,
      label: 'Yer',
      value: 'Ali Ulvi Kurucu Gençlik Merkezi',
    },
    {
      icon: <Users size={24} className='text-[#AC5E2A]' />,
      label: 'Kapasite',
      value: '216 Kişi',
    },
    {
      icon: <Users size={24} className='text-[#AC5E2A]' />,
      label: 'Süre',
      value: '1 saat 55 dakika',
    },
    {
      icon: <Info size={24} className='text-[#AC5E2A]' />,
      label: 'Kategori',
      value: 'Dram, Biyografi, Aile'.split(',').map((g, idx) => (
        <span key={idx} className='bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs me-1'>
          {g.trim()}
        </span>
      )),
    },
  ]

  return (
    <Fragment>
      <h2 className='text-lg font-bold text-gray-800 mb-2'>Salon Bilgileri</h2>
      <div className='bg-white rounded-xl p-6 shadow-md border border-[#AC5E2A]'>
        <div className='space-y-4'>
          {infoItems.map((item, idx) => (
            <div key={idx} className='flex items-center gap-4'>
              <div className='bg-[#AC5E2A]/10 p-3 rounded-lg'>{item.icon}</div>
              <div>
                <p className='text-sm text-gray-600 text-start'>{item.label}</p>
                <p className='font-semibold text-gray-800'>{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  )
}

export default CinemaInfo
